import { render } from "./Button.vue?vue&type=template&id=e05569f4&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=e05569f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e05569f4"]])

export default __exports__